import styled from 'styled-components';
import { colors } from 'theme';

export const HeaderTitle = styled.span`
    font-weight: bold;
    white-space: nowrap;
`;
export const TemplateTitle = styled.p`
    font-size: 24px;
    font-weight: bold;

    margin-bottom: 0;
`;
export const XButton = styled.div`
    cursor: pointer;
    margin-left: 2rem;
    font-size: 1.8rem;
    text-align: center;
    color: ${colors.lightGrey3};
    transition: color 100ms;

    :hover {
        color: initial;
        font-weight: bold;
    }
`;
